import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';
import { confirmation }    from './confirmation';

@Injectable()
export class ConfirmationService {

  // Observable string sources
  private announceSource = new Subject<confirmation>();

  // Observable string streams
  announceConfirmation$ = this.announceSource.asObservable();

  sendConfirmationNumber(confirmationNumber: confirmation) {
    this.announceSource.next(confirmationNumber);
  }
}
